import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InversionistaDataSimulacionService {

  private inversionistaDataSimulacion = new BehaviorSubject<any>({});
  inversionistaDataSimulacion$ = this.inversionistaDataSimulacion.asObservable();

  setInversionistaDataSimulacion(data: any) {
    this.inversionistaDataSimulacion.next(data);
  }

  getInversionistaDataSimulacion() {
    return this.inversionistaDataSimulacion.getValue();
  }
}
